const setShareProductPage = () => {
  var shareBtn = document.querySelector("#share-product-btn");
  var shareCloseBtn = document.querySelector("#share-close");
  var shareBlock = document.querySelector(".share_block");
  var copyBtn = document.querySelector(".share-url-copy");
  var copyText = document.getElementById("p-share-url");
  shareBtn.addEventListener("click", (event) => {
    shareBlock.style.display = "block";
  });
  shareCloseBtn.addEventListener("click", (event) => {
    shareBlock.style.display = "none";
    copyBtn.innerText = "Copy";
  });
  copyBtn.addEventListener("click", (event) => {
    navigator.clipboard.writeText(copyText.value);
    copyBtn.innerText = "Copied";
  });
  //share btn
  var share_facebook_btn = document.querySelector(".share_facebook_btn");
  var share_twitter_btn = document.querySelector(".share_twitter_btn");
  var share_instagram_btn = document.querySelector(".share_instagram_btn");
  var share_pinterest_btn = document.querySelector(".share_pinterest_btn");
  share_facebook_btn.addEventListener("click", (event) => {
    const _url ="https://www.facebook.com/sharer/sharer.php?u=" + copyText.value;
    openShareWindow(_url, "Facebook");
  });
  share_twitter_btn.addEventListener("click", (event) => {
    const _url ="https://twitter.com/intent/tweet?original_referer=" + copyText.value;
    openShareWindow(_url, "Twitter");
  });
  share_pinterest_btn.addEventListener("click", (event) => {
    const _url ="https://pinterest.com/pin/create/button/?url=" + copyText.value;
    openShareWindow(_url, "Facebook");
  });
};

const openShareWindow = (url, title) => {
  var r = window.screenLeft || window.screenX;
  var l = r + window.innerWidth / 2 - 375 || 0;
  window.open(url, title, "left="+l+",top=100,width=750,height=400");
};

setShareProductPage();
